import request from '@/utils/request'

export function getList(params) {
  return request({
    url: '/pointCards/load',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/pointCards/add',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/pointCards/update',
    method: 'post',
    data
  })
}

export function del(data) {
  return request({
    url: '/pointCards/delete',
    method: 'post',
    data
  })
}

